/**
 * 与 fin-web-components 内 `EasyReadTime` 保持逻辑一致；
 * git 尚未发布导出 `getEasyReadTime` 时跟进池等处由此导入；发布后可视情况改为包导出。
 */
const API_DT = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})$/;

function toDate(input: unknown): Date | null {
  if (input == null || input === "") return null;
  if (input instanceof Date) {
    return Number.isNaN(input.getTime()) ? null : input;
  }
  if (typeof input === "string") {
    const t = input.trim();
    if (!t) return null;
    const m = API_DT.exec(t);
    if (m) {
      const y = Number(m[1]);
      const mo = Number(m[2]);
      const d = Number(m[3]);
      const h = Number(m[4]);
      const mi = Number(m[5]);
      const s = Number(m[6]);
      const dt = new Date(y, mo - 1, d, h, mi, s);
      return Number.isNaN(dt.getTime()) ? null : dt;
    }
    const dt = new Date(t.replace(/-/g, "/"));
    return Number.isNaN(dt.getTime()) ? null : dt;
  }
  return null;
}

/** 相对当前时间展示简短时间（今日仅时分、本周星期+时分、否则月日+时分）。支持 Date、后端常见 `YYYY-MM-DD HH:mm:ss` 字符串 */
export function getEasyReadTime(input: Date | string | null | undefined): string {
  const date = toDate(input);
  if (!date) {
    return "—";
  }
  const now = new Date();
  const options: Intl.DateTimeFormatOptions = {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  };
  const timeString = date.toLocaleTimeString([], options);

  if (
    date.getFullYear() === now.getFullYear() &&
    date.getMonth() === now.getMonth() &&
    date.getDate() === now.getDate()
  ) {
    return timeString;
  }

  const startOfWeek = new Date(now);
  startOfWeek.setDate(now.getDate() - (now.getDay() === 0 ? 6 : now.getDay() - 1));

  if (
    date >= startOfWeek &&
    date < new Date(startOfWeek.getTime() + 7 * 24 * 60 * 60 * 1000)
  ) {
    const weekDays = ["星期一", "星期二", "星期三", "星期四", "星期五", "星期六", "星期日"];
    const weekDay = weekDays[date.getDay() === 0 ? 6 : date.getDay() - 1];
    return `${weekDay} ${timeString}`;
  }

  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  return `${month}月${day}日 ${timeString}`;
}
